export default __webpack_public_path__ + "static/media/icon_data.0a68db4c.svg";